import { createSelector } from 'reselect';

const getTeamState = (state) => state.team;

export const getTeamByIds = createSelector([getTeamState], (team) => team.teams);
export const getTeamById = ({ teamId }) =>
  createSelector([getTeamState], (team) => team.teams.find((team) => team._id === teamId));
